var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "cover-image-delete-confirm-mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClickCancel.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          ref: "dialogRoot",
          staticClass: "cover-image-delete-confirm-dialog",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": _vm.titleId,
            tabindex: "-1",
          },
        },
        [
          _c(
            "header",
            { staticClass: "cover-image-delete-confirm-dialog__header" },
            [
              _c("div", {
                staticClass: "cover-image-delete-confirm-dialog__header-spacer",
                attrs: { "aria-hidden": "true" },
              }),
              _c(
                "h2",
                {
                  staticClass: "cover-image-delete-confirm-dialog__title",
                  attrs: { id: _vm.titleId },
                },
                [_vm._v(_vm._s(_vm.title))]
              ),
              _c(
                "button",
                {
                  staticClass: "cover-image-delete-confirm-dialog__close",
                  attrs: {
                    type: "button",
                    "aria-label": String(_vm.$t("common.close")),
                  },
                  on: { click: _vm.onClickCancel },
                },
                [_c("IconClose")],
                1
              ),
            ]
          ),
          _c(
            "p",
            { staticClass: "cover-image-delete-confirm-dialog__message" },
            [_vm._v(_vm._s(_vm.content))]
          ),
          _c(
            "button",
            {
              staticClass: "cover-image-delete-confirm-danger-button",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$close(true)
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.okButton || _vm.$t("common.yes")) + " ")]
          ),
          _c(
            "button",
            {
              staticClass: "cover-image-delete-confirm-cancel-button",
              attrs: { type: "button" },
              on: { click: _vm.onClickCancel },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.cancelButton || _vm.$t("common.cancel")) + " "
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }